export class AlteraSenhaRequest {
  public token: string
  public password: string
  public confirmPassword: string
}